  <div class="display-utils-col display-utils-gap-24">
    <div>
      <div class="display-utils-row display-utils-center">
        <div *ngIf="type == 'new-success'" class="success-logo">
          <img src="../../../../assets/images/feather-icons/OrderSuccess.svg">
        </div>
        <div *ngIf ="type !== 'new-success'" class="pme-icon" [ngClass]="{
            'pme-icon-error'    : type == 'error',
            'pme-icon-success'  : type == 'success',
            'pme-icon-warn'     : type == 'warn',
            'pme-icon-info'     : type == 'info' ||  type == 'money-info' || type == 'upgrade-info'
          }">

          
          
          <mat-icon class="pme-alert-icon" svgIcon="new-error"    *ngIf="type == 'error'"></mat-icon>
          <mat-icon class="pme-alert-icon" svgIcon="new-success"  *ngIf="type == 'success'"></mat-icon>
          <mat-icon class="pme-alert-icon" svgIcon="new-warn"     *ngIf="type == 'warn'"></mat-icon>
          <mat-icon class="pme-alert-icon" *ngIf="type == 'info'">info</mat-icon>
          <mat-icon class="pme-alert-icon" *ngIf="type == 'money-info'">monetization_on</mat-icon>
          <mat-icon class="pme-alert-icon" *ngIf="type == 'upgrade-info'">verified</mat-icon>
        </div>
      </div>

      <h1 class="mat-headline"  [ngClass]="{
        'mat-headline-error'    : type == 'error',
        'mat-headline-success'  : type == 'success',
        'new-sucess-text'   : type == 'new-success',
        'mat-headline-warn'     : type == 'warn',
        'mat-headline-info'     : type == 'info' ||  type == 'money-info' || type == 'upgrade-info'
      }" [innerHTML]="title"></h1>

      <ng-content></ng-content>
    </div>

    <div class="display-utils-center" *ngIf="this.showButton">
      <a mat-flat-button color="primary" href="{{this.redirectURL}}">{{buttonName}}</a>
    </div>
  </div>
